(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports);
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports);
    global.he = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _default = {
    el: {
      datepicker: {
        apply: 'Apply',
        // to be translated
        clearSelection: 'Clear selection',
        // to be translated
        pickADays: 'Select days',
        // to be translated
        now: 'כעת',
        today: 'היום',
        cancel: 'בטל',
        clear: 'נקה',
        confirm: 'אישור',
        selectDate: 'בחר תאריך',
        selectTime: 'בחר זמן',
        startDate: 'תאריך התחלה',
        startTime: 'זמן התחלה',
        endDate: 'תאריך סיום',
        endTime: 'זמן סיום',
        prevYear: 'Previous Year',
        // to be translated
        nextYear: 'Next Year',
        // to be translated
        prevMonth: 'Previous Month',
        // to be translated
        nextMonth: 'Next Month',
        // to be translated
        year: '',
        month1: 'ינואר',
        month2: 'פברואר',
        month3: 'מרץ',
        month4: 'אפריל',
        month5: 'מאי',
        month6: 'יוני',
        month7: 'יולי',
        month8: 'אוגוסט',
        month9: 'ספטמבר',
        month10: 'אוקטובר',
        month11: 'נובמבר',
        month12: 'דצמבר',
        weeks: {
          sun: 'א׳',
          mon: 'ב׳',
          tue: 'ג׳',
          wed: 'ד׳',
          thu: 'ה׳',
          fri: 'ו׳',
          sat: 'שבת'
        },
        months: {
          jan: 'ינואר',
          feb: 'פברואר',
          mar: 'מרץ',
          apr: 'אפריל',
          may: 'מאי',
          jun: 'יוני',
          jul: 'יולי',
          aug: 'אוגוסט',
          sep: 'ספטמבר',
          oct: 'אוקטובר',
          nov: 'נובמבר',
          dec: 'דצמבר'
        },
        pickADay: 'Select a day'
      },
      select: {
        loading: 'טוען',
        noMatch: 'לא נמצאו נתונים',
        noData: 'ללא נתונים',
        placeholder: 'בחר'
      },
      pagination: {
        goto: 'עבור ל',
        pagesize: '/page',
        total: 'כולל {total}',
        pageClassifier: ''
      },
      upload: {
        deleteTip: 'press delete to remove',
        // to be translated
        delete: 'מחק',
        preview: 'תצוגה מקדימה',
        continue: 'המשך'
      },
      table: {
        emptyText: 'אין נתונים',
        confirmFilter: 'אישור',
        resetFilter: 'נקה',
        clearFilter: 'הכל',
        sumText: 'סך'
      },
      tree: {
        emptyText: 'אין נתונים'
      }
    }
  };
  _exports.default = _default;
});